import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { MatTooltip } from '@angular/material/tooltip';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import { FlexDirective, FlexOrderDirective, LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';
import * as _ from 'lodash';
import { CaptureEvent } from '../../models/capture-event';
import { CaptureEventViewReview } from '../../models/capture-event-view-review';
import { RobotService } from '../../services/robot.service';

@Component({
  selector: 'bt-capture-event-review-detail',
  templateUrl: './capture-event-review-detail.component.html',
  styleUrls: ['./capture-event-review-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FlexDirective,
    FlexOrderDirective,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatCard,
    MatCardContent,
    MatIcon,
    MatIconButton,
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
    MatTab,
    MatTabGroup,
    MatTabLabel,
    MatTooltip,
    NgTemplateOutlet,
    StartCasePipe
  ]
})
export class CaptureEventReviewDetailComponent implements OnChanges {
  @ContentChild(TemplateRef) reviewDetailTemplate;
  @Input() captureEvent: CaptureEvent;
  review: CaptureEventViewReview;
  activeTab: number;
  @Output() close = new EventEmitter();

  constructor(private robotService: RobotService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    const captureEventChange = changes['captureEvent'];
    if (
      _.get(captureEventChange, 'currentValue.id') !==
      _.get(captureEventChange, 'previousValue.id')
    ) {
      this.selectReview(
        _.get(this.captureEvent, ['views', '0', 'reviews', '0', 'id'])
      ); // Select the first review
      this.activeTab = 0; // Reset to the first review tab
    }
  }

  onClose() {
    this.close.emit(null);
  }

  selectReview(id: number) {
    if (id) {
      this.robotService
        .getCaptureEventReview(id)
        .subscribe((review) => (this.review = review));
    }
    else {
      this.review = null;
    }
  }

  getImageLabel(camera_label: any) {
    return _.replace(camera_label, 'clean_sweep_', '');
  }
}
